import React, { useState } from 'react';
import { Box, Button, Chip, Divider, Grid, Paper, Stack } from '@mui/material';
import { IQuestion } from '../../../store/QuestionSlice';
import AnswerListItem from './AnswerListItem';
import {
  getQuestionDifficultyChipColor,
  isMobileScreen,
} from '../../../helper';

export interface IQuestionPage {
  questionData: IQuestion;
  questionNo: number;
}

const labelStyles: React.CSSProperties = {
  borderRadius: '4px',
  fontWeight: 600,
};

const QuestionItem: React.FC<IQuestionPage> = ({
  questionData,
  questionNo,
}) => {
  // State
  const [showAnswer, setShowAnswer] = useState<boolean>(false);

  const handleCheckAnswer = () => {
    setShowAnswer((prevState) => !prevState);
  };

  return (
    <Paper
      style={{
        padding: '30px',
        borderRadius: '7px',
        marginTop: '30px',
        width: '70%',
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignItems="center">
          <Chip
            label={`Question ${(questionNo + 1).toString().padStart(2, '0')}`}
            style={labelStyles}
          />
        </Box>
        <Box alignItems="center">
          {!isMobileScreen() && (
            <Chip
              label={`${questionData.marks.toString().padStart(2, '0')} Marks`}
              style={{ ...labelStyles, marginRight: '10px' }}
            />
          )}
          <Chip
            label={questionData.difficulty}
            style={labelStyles}
            color={getQuestionDifficultyChipColor(questionData.difficulty)}
          />
        </Box>
      </Stack>
      <Divider style={{ marginTop: '10px' }} />
      <div
        className="view ql-editor ql-viewer"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: questionData.details,
        }}
        style={{ marginBottom: '10px', fontWeight: 600 }}
      />
      {/* ANSWER LIST */}
      <Grid container spacing={1}>
        {questionData.answers.map((answer, index) => (
          <Grid key={index} item xs={12}>
            <AnswerListItem
              answer={answer}
              showAnswer={showAnswer}
              markingSchema={questionData.markingSchema}
            />
          </Grid>
        ))}
      </Grid>

      <Button
        fullWidth
        variant="contained"
        color="secondary"
        style={{ marginTop: '20px' }}
        onClick={handleCheckAnswer}
      >
        {showAnswer ? 'Hide Answer' : 'Show Answer'}
      </Button>
    </Paper>
  );
};

export default QuestionItem;
